import config from 'config';

export function getProExpertUrl() {
  const baseURL = config.mode === 'development'
    ? 'http://localhost:3015/' // or whatever route your professional-system client is running on
    : '/';

  return `${baseURL}proExpert`;
}
